import React, { Fragment } from "react";
import {
  FormControl,
  InputLabel,
  Grid,
  Input,
  FormHelperText
} from "@material-ui/core";
import inputComponentMask from "lib/inputMask";
import { withStyles } from "@material-ui/core/styles";
import ViewOnlyField from "components/Global/Fields/ViewOnlyField";

const styles = theme => ({
  label:{
    fontWeight:"bold",
    color:"black"
  }
});

let valueError = false;
class GridPercentInput extends React.Component {
  validate = () => {
    valueError = Boolean(this.props.value) && (this.props.value > 100 || this.props.value < -100);
  };

  render() {

 
    this.validate();
    return (
      this.props.shouldShow && (
        <Fragment>
          <Grid item xs={3}>
            <InputLabel className={this.props.classes.label} htmlFor={this.props.name}>
              {this.props.label}
            </InputLabel>
          </Grid>
          <Grid item xs={4}>
            {!this.props.isEditing && 
             <ViewOnlyField value={this.props.value} mask="percent3Decimal"/>
            }

            {this.props.isEditing &&  
              <FormControl fullWidth error={valueError}>
                <Input
                  disabled={!this.props.isEditing}
                  type="text"
                  name={this.props.name}
                  value={this.props.value}
                  onBlur={this.props.onBlur}
                  inputComponent={inputComponentMask({
                    mask: "percent3Decimal"
                  })}
                />
                {valueError ? (
                  <FormHelperText>
                    Value must be between -100% and 100%
                  </FormHelperText>
                ) : null}
              </FormControl>
            }

          </Grid>
        </Fragment>
      )
    );
  }
}

export default withStyles(styles, { withTheme: true })(GridPercentInput);
